/* ==========================================================================
   Wereld-hero: titelregels komen van onderen in, de rest faadt gestaffeld in

   De titel wordt per regel gesplitst (SplitText, met masker per regel). Na
   een wijziging van de schermbreedte splitst autoSplit opnieuw en loopt de
   animatie op dezelfde plek door.

   Geen animatie (en dus meteen de eindstand) bij: geen data-wh-animatie,
   verminderde beweging, of een GSAP dat niet laadt. data-wh-klaar haalt de
   verberg-regel uit wereld-hero.css weg.

   Het element ruimt zichzelf op als het uit de pagina gaat
   (shopify:section:unload in de editor) en start opnieuw als het terugkomt
   (shopify:section:load): connectedCallback en disconnectedCallback dekken
   dat, er hoeven geen losse listeners op document te staan.
   ========================================================================== */

/* Eén keer per pagina uitgevoerd in een eigen scope: een sectie die twee keer
   op de pagina staat laadt dit bestand twee keer, en een klasse op het niveau
   van het bestand zou dan een fout geven. */
(() => {
  class WereldHero extends HTMLElement {
    connectedCallback() {
      this.gestart = false;
      // Wie de voorkeur voor beweging tijdens het bezoek wijzigt, krijgt direct
      // de juiste staat zonder te herladen
      this.stopVoorkeur = window.elGsap?.opVoorkeurWijziging(() => this.opnieuw());
      this.start();
    }

    disconnectedCallback() {
      this.stopVoorkeur?.();
      this.opruimen();
    }

    opnieuw() {
      this.opruimen();
      this.start();
    }

    opruimen() {
      this.gestart = false;
      // Zet alles terug zoals Liquid het schreef: SplitText wordt teruggedraaid
      this.context?.revert();
      this.context = null;
    }

    async start() {
      if (this.gestart) return;
      this.gestart = true;

      const uitgezet = !this.hasAttribute('data-wh-animatie');
      if (uitgezet || !window.elGsap || window.elGsap.verminderdeBeweging()) {
        this.setAttribute('data-wh-klaar', '');
        return;
      }

      try {
        const { gsap, SplitText } = await window.elGsap.laad(this, ['SplitText']);
        // Wacht op de lettertypes: anders meet SplitText de regels met het
        // vangnet-lettertype en breekt de kop op de verkeerde plek
        if (document.fonts?.ready) await document.fonts.ready;
        // In de tussentijd verwijderd of opnieuw gestart: niets meer doen
        if (!this.isConnected || !this.gestart) return;

        const titel = this.querySelector('[data-wh-titel]');
        const inBeeld = this.querySelectorAll('[data-wh-in]');
        const pillen = this.querySelectorAll('[data-wh-pil]');

        this.context = gsap.context(() => {
          if (titel && SplitText) {
            SplitText.create(titel, {
              type: 'lines',
              mask: 'lines',
              autoSplit: true,
              onSplit: (zelf) => {
                // Beginstand expliciet: bij een gestaffelde from() staan de latere regels anders nog niet op hun plek
                gsap.set(zelf.lines, { yPercent: 115 });
                this.setAttribute('data-wh-klaar', '');
                return gsap.to(zelf.lines, {
                  yPercent: 0,
                  duration: 1.1,
                  ease: 'power4.out',
                  stagger: 0.12,
                });
              },
            });
          } else {
            this.setAttribute('data-wh-klaar', '');
          }

          if (inBeeld.length) {
            gsap.set(inBeeld, { opacity: 0, y: 14 });
            gsap.to(inBeeld, {
              opacity: 1,
              y: 0,
              duration: 0.9,
              ease: 'power2.out',
              stagger: 0.1,
              delay: 0.15,
              clearProps: 'transform,opacity',
            });
          }
          if (pillen.length) {
            gsap.set(pillen, { opacity: 0, y: 16 });
            gsap.to(pillen, {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: 'power2.out',
              stagger: 0.09,
              delay: 0.55,
              clearProps: 'transform,opacity',
            });
          }
        }, this);
      } catch {
        // Mislukt het laden, dan staat de kop gewoon op zijn eindstand
        this.setAttribute('data-wh-klaar', '');
      }
    }
  }

  if (!customElements.get('wereld-hero')) {
    customElements.define('wereld-hero', WereldHero);
  }
})();
